import React, { FC } from 'react';
import styles from './SortingMobileDrawer.module.scss';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Drawer from '@/components/UI/drawer/Drawer';
import Typography from '@/components/UI/typography/Typography';
interface SortingMobileDrawerTypes {
  open: boolean;
  handleClose: () => void;
  handleClick: (index: number) => () => void;
  list: {
    index: number;
    label: string;
  }[];
}
const SortingMobileDrawer: FC<SortingMobileDrawerTypes> = ({
  open,
  handleClose,
  handleClick,
  list
}) => {
  return <Drawer open={open} onClose={handleClose} anchor="bottom" data-sentry-element="Drawer" data-sentry-component="SortingMobileDrawer" data-sentry-source-file="SortingMobileDrawer.tsx">
      <Box className={styles['sorting-mobile-drawer-container']} data-sentry-element="Box" data-sentry-source-file="SortingMobileDrawer.tsx">
        <Box className={styles['sorting-mobile-header']} data-sentry-element="Box" data-sentry-source-file="SortingMobileDrawer.tsx">
          <Box onClick={handleClose} className={styles['close-icon-section']} data-sentry-element="Box" data-sentry-source-file="SortingMobileDrawer.tsx">
            <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="SortingMobileDrawer.tsx" />
          </Box>
          <Typography variant="title_Bold" data-sentry-element="Typography" data-sentry-source-file="SortingMobileDrawer.tsx">مرتب سازی بر اساس</Typography>
        </Box>
        <Box className={styles['sorting-mobile-item-container']} data-sentry-element="Box" data-sentry-source-file="SortingMobileDrawer.tsx">
          {list.map(item => <Box key={item.index} onClick={handleClick(item.index)} className={styles['sorting-mobile-item']}>
              <Typography variant="bodyL">{item.label}</Typography>
            </Box>)}
        </Box>
      </Box>
    </Drawer>;
};
export default SortingMobileDrawer;